import React, { Component } from 'react';
import { GoogleMap, Marker, InfoWindow, LoadScript } from '@react-google-maps/api';
import * as util from '../../library/utilitys';

const containerStyle = {
  width: '100%',
  height: '500px'
};

const center = {
  lat: 13.5,
  lng: 101.0
};

class DashboardGoogleMap extends Component {
  state = {
    activeMarker: null
  };

  handleActiveMarker = (marker) => {
    if (marker === this.state.activeMarker) return;
    this.setState({ activeMarker: marker });
  };

  handleMapClick = () => {
    if (this.state.activeMarker !== null) {
      this.setState({ activeMarker: null });
    }
  };

  render() {
    const { mapData = [] } = this.props;

    return (
      <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={7}
          onClick={this.handleMapClick}
        >
          {mapData.map((entry, index) => {
            const lat = parseFloat(entry.latitude);
            const lng = parseFloat(entry.longitude);
            const name = entry.enterprise_name?.trim() || 'ไม่ทราบชื่อ';
            const location = util.formatThaiAddress({
              province_name: entry.province_name,
              district_name: entry.district_name,
              subdistrict_name: entry.subdistrict_name,
              address: entry.address || '', // safe fallback
              zip_code: entry?.zip_code || ''
            });

            return (
              <Marker
                key={index}
                position={{ lat, lng }}
                onClick={() => this.handleActiveMarker(index)}
              >
                {this.state.activeMarker === index && (
                  <InfoWindow onCloseClick={() => this.setState({ activeMarker: null })}>
                    <div style={{ fontSize: '14px', maxWidth: '500px' }}>
                      <strong>{name}</strong><br />
                      {location}
                    </div>
                  </InfoWindow>
                )}
              </Marker>
            );
          })}
        </GoogleMap>
      </LoadScript>
    );
  }
}

export default DashboardGoogleMap;
